import { getQueryPropsForContentType } from "@/domains/datablocks/fields/contentTypeConfig";
import { ContentTypeRelations } from "@/domains/datablocks/types";
import { ContentType } from "@/redux/datablocks/types";

export const useDataBlockRelatedData = (
  ids: number | number[],
  type?: ContentType,
): {
  data: ContentTypeRelations;
  isLoading: boolean;
  isSuccess: boolean;
} => {
  const idsArray = Array.isArray(ids) ? ids : ids ? [ids] : [];

  const queryParams = {
    ids: idsArray.filter((i) => Boolean(i)),
    pagination: "off" as const,
  };

  const queryConfig = type ? getQueryPropsForContentType(type) : null;
  const shouldSkip = idsArray.length === 0;

  const { data, isLoading, isSuccess } = queryConfig
    ? queryConfig.useQuery(queryParams, { skip: shouldSkip })
    : { data: null, isLoading: false, isSuccess: false };

  if (shouldSkip) {
    return {
      data: [] as ContentTypeRelations,
      isLoading: false,
      isSuccess: true,
    };
  }

  return {
    data: (data as ContentTypeRelations) ?? null,
    isLoading,
    isSuccess,
  };
};
